import React, { Fragment, useState} from 'react'
import { Row, Col, Container} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { FaRegFileAlt } from "react-icons/fa";
import { VerInformeProfesionalComponent } from 'defcol-caso-general';

const GrillaSolicitudes = ({cfg_form, solicitudes}) => {
    const ESTADO_INFORME_EMITIDO = 300004;
    const { SearchBar, ClearSearchButton } = Search;
    const [rowSelected, setRowSelected] = useState(false)
    // ver Informe Profesional
    const [showVerInformeProfesional, setShowVerInformeProfesional] = useState(false)

    const handleDetalle = (row) => {
        setRowSelected(row);      
        setShowVerInformeProfesional(true);
    }

  const columnas = [
      {
          dataField: 'idSolicitud',
          text: (cfg_form && cfg_form["solicita-informe-grilla-idsol"]) ? cfg_form["solicita-informe-grilla-idsol"] : 'ID Solicitud',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'tipoInforme',
          text: (cfg_form && cfg_form["solicita-informe-grilla-tipoinf"]) ? cfg_form["solicita-informe-grilla-tipoinf"] : 'Tipo Informe',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'implicado',
          text: (cfg_form && cfg_form["solicita-informe-grilla-impl"]) ? cfg_form["solicita-informe-grilla-impl"] : 'Implicado',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'fecSolicitudFormat',
          text: (cfg_form && cfg_form["solicita-informe-grilla-fechasol"]) ? cfg_form["solicita-informe-grilla-fechasol"] : 'Fecha Solicitud',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'fecAutorizaFormat',
          text: (cfg_form && cfg_form["solicita-informe-grilla-fechaauto"]) ? cfg_form["solicita-informe-grilla-fechaauto"] : 'Fecha Autoriza',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'gestor',
          text: (cfg_form && cfg_form["solicita-informe-grilla-gestor"]) ? cfg_form["solicita-informe-grilla-gestor"] : 'Gestor Asignado',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'fecEnvioInformeFormat',
          text: (cfg_form && cfg_form["solicita-informe-grilla-fechaenvinf"]) ? cfg_form["solicita-informe-grilla-fechaenvinf"] : 'Envío Informe',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'estadoSolicitud',
          text: (cfg_form && cfg_form["solicita-informe-grilla-estadosol"]) ? cfg_form["solicita-informe-grilla-estadosol"] : 'Estado Solicitud',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'comentario',
          text: (cfg_form && cfg_form["solicita-informe-grilla-comentario"]) ? cfg_form["solicita-informe-grilla-comentario"] : 'Comentario',
          sort: true, headerAlign: 'center', align: 'center',
          headerStyle: { color: 'white', backgroundColor: '#7594C1' },
          headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
      },
      {
          dataField: 'opciones',
          text: (cfg_form && cfg_form["solicita-informe-grilla-comentario"]) ? cfg_form["solicita-informe-grilla-accion"] : 'Ver',
          isDummyField: true,
          style: { textAlign: 'center', verticalAlign: 'middle' },
          headerStyle: (colum, colIndex) => {
              return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
          },
          formatter: (cell, row) => {
            const isDisabled = row.codEstadoSolicitud != ESTADO_INFORME_EMITIDO;
            return (
                <FaRegFileAlt
                    size={20}
                    title={isDisabled ? "No disponible" : "Ver Informe"}
                    style={{
                        color: isDisabled ? 'lightgray' : 'gray',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.5 : 1,
                    }}
                    onClick={() => {
                     if (!isDisabled) handleDetalle(row);
                    }}
                />
            );
          },
      }
  ];

    return (
        <>
         
        <Container>
            
            <Row className='mt-4 mb-3'>
                <Col>
                    <ToolkitProvider
                    search
                    bootstrap4
                    keyField="id"
                    data={solicitudes ? solicitudes : []}
                    columns={columnas}
                    defaultSorted={[{ dataField: 'id', order: 'asc' }]}>
                    {props =>
                        <>
                            <Row>
                                <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                    <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                    <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                </Col>
                            </Row>
                            <BootstrapTable
                                {...props.baseProps}
                                headerWrapperClasses="table-secondary"
                                noDataIndication={
                                    <div className="text-center">No hay registros encontrados.</div>
                                }
                            />
                        </>
                    }
                </ToolkitProvider>
              </Col>
            </Row>
        </Container>
        <VerInformeProfesionalComponent
            idCaso={rowSelected?.idCaso}
            idSolicitud={rowSelected?.idSolicitud}
            showModal={showVerInformeProfesional}
            setShowModal={setShowVerInformeProfesional}
        />
        </>
  )
}
export default GrillaSolicitudes
